<div class="row">
	<div class="col-xs-12">
		<!-- Loading spinner -->
		<span *ngIf="loading">
			<i class="fa fa-lg fa-spin fa-refresh fa-fw"></i>
		</span>

		<!-- Addresses -->
		<div *ngIf="partyContactMechanisms.length > 0 && checkCategory('Address')">
			<ng-container *ngFor="let postalAddress of partyContactMechanisms; let last = last">
				<div *ngIf="!inLine">
					<b>{{ postalAddress.PARTY_CONTACT_MECHANISM_PURPOSES[0].CONTACT_MECHANISM_PURPOSE_TYPES.TYPE }}</b>
				</div>

				<div>
					<span *ngIf="inLine">
						<b>
							{{
							postalAddress.PARTY_CONTACT_MECHANISM_PURPOSES[0]
							.CONTACT_MECHANISM_PURPOSE_TYPES.TYPE | slice:0:1
							}}:
						</b>
					</span>

					{{ postalAddress.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0].STREET_1 | titlecase }},
					<br *ngIf="!inLine" />

					<span *ngIf="
              postalAddress.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0].STREET_2 &&
              !inLine
            ">
						{{ postalAddress.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0].STREET_2 | titlecase }}
						<br />
					</span>

					{{
					postalAddress.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0].CITy.CITY_NAME
					| titlecase
					}}
					{{
					postalAddress.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0].CITy.STATE.STATE_CODE
					}},
					{{
					postalAddress.CONTACT_MECHANISMS.POSTAL_ADDRESSES[0].POSTAL_CODES.POSTAL_CODE
					}}
				</div>

				<br *ngIf="!last" />
			</ng-container>
		</div>

		<!-- Emails -->
		<div *ngIf="partyContactMechanisms.length > 0 && checkCategory('Email')">
			<ng-container *ngFor="let email of partyContactMechanisms; let last = last">
				<div *ngIf="!inLine">
					<b>{{ email.PARTY_CONTACT_MECHANISM_PURPOSES[0].CONTACT_MECHANISM_PURPOSE_TYPES.TYPE }}</b>
				</div>

				<div>
					<span *ngIf="inLine">
						<b>
							{{
							email.PARTY_CONTACT_MECHANISM_PURPOSES[0]
							.CONTACT_MECHANISM_PURPOSE_TYPES.TYPE | slice:0:1
							}}:
						</b>
					</span>

					{{ email.CONTACT_MECHANISMS.EMAILS[0].EMAIL_ADDRESS }}
				</div>

				<br *ngIf="!last" />
			</ng-container>
		</div>

		<!-- Telephone Numbers -->
		<div *ngIf="partyContactMechanisms.length > 0 && checkCategory('Phone')">
			<ng-container *ngFor="let phone of partyContactMechanisms; let last = last">
				<div *ngIf="!inLine">
					<b>{{ phone.PARTY_CONTACT_MECHANISM_PURPOSES[0].CONTACT_MECHANISM_PURPOSE_TYPES.TYPE }}</b>
				</div>

				<div>
					<span *ngIf="inLine">
						<b>
							{{
							phone.PARTY_CONTACT_MECHANISM_PURPOSES[0]
							.CONTACT_MECHANISM_PURPOSE_TYPES.TYPE | slice:0:1
							}}:
						</b>
					</span>

					{{ phone.CONTACT_MECHANISMS.TELEPHONE_NUMBERS[0].PHONE_NUMBER }}

					<span *ngIf="phone.CONTACT_MECHANISMS.TELEPHONE_NUMBERS[0].EXT?.length > 0">
						Ext. {{ phone.CONTACT_MECHANISMS.TELEPHONE_NUMBERS[0].EXT }}
					</span>
				</div>

				<br *ngIf="!last" />
			</ng-container>
		</div>
	</div>
</div>